// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"0fb47f49","768":"fb840bfb","869":"a55d3f05"}[chunkId] + ".chunk.js";
};